import { useRegionCode } from "modules/i18n/hooks/useRegionCode"
import svgLogo from "common/assets/logo.svg"

interface TcLogoProps {
  width: number
  height: number
}

export const TcLogo = ({ width, height }: TcLogoProps) => {
  const regionCode = useRegionCode()

  return (
    <a href={`/${regionCode}`}>
      <img alt="The Conversation" src={svgLogo.src} width={width} height={height} />
    </a>
  )
}
